module.exports = __webpack_public_path__ + "static/WEDDING E&M-395-65d7c9df6208cbec5426697cbeed9086.jpg";